<template lang="pug">
  form.funcionarioForm.g12(onsubmit="return false" @submit="send")
    h3 DADOS PESSOAIS
    .row.wp.ja.col-s
      .col.g2.g12-s
        label CPF
        input(v-model="form.cpf" v-mask="'###.###.###-##'" required)
      .col.g2.g12-s
        label RG 
          i (rg, emissor, estado)
        input(v-model="form.rg" placeholder="Rg, Emissor, Estado" required)
      .col.g2.g12-s
        label Nome
        input(v-model="form.nome" placeholder="Nome" required)
      .col.g3.g12-s
        label E-mail
        input(v-model="form.email" required)
      .col.g2.g-12-s
        label grupo
        select(v-model="form.id_grupo")
          option(v-for="g in grupo" :value="g.id") {{g.nome}}
      .col.g2.g12-s
        label Telefone
        input(v-model="form.fone" placeholder="Telefone" v-mask="'(##) #####-####'" required)
      .col.g2.g12-s
        label Celular
        input(v-model="form.celular" placeholder="Celular" v-mask="'(##) #####-####'" required)
      .col.g2.g12-s
        label Data Nascimento
        input(v-model="form.dt_nascimento" v-mask="'##/##/####'" placeholder="Data Nascimento")
      .col.g2.g12-s
        label Sexo
        select(v-model="form.sexo" required)
          option(value) Selecione
          option(value="M") Masculino
          option(value="F") Feminino
      .col.g2.g12-s
        label PCD
        select(v-model="form.pcd" required)
          option(value) Selecione
          option(value="N") Não
          option(value="S") Sim
      .col.g2.g12-s
        label Usuário NS Community
        input(v-model="form.usuario_discourse" placeholder="Usuário Discourse")
    h3 ENDEREÇO
    .row.g12.wp.col-s.ja
      .col.g2.g12-s
        label CEP
        input(v-model="form.cep" placeholder="CEP" v-mask="'##.###-###'" @input="cep" required)
      .col.g2.g12-s
        label Cidade
        input(v-model="form.cidade" placeholder="Cidade")
      .col.g3.g12-s
        label Logradouro
        input(v-model="form.logradouro" placeholder="Logradouro" required)
      .col.g2.g12-s
        label Número
        input(v-model="form.numero" placeholder="Número")
      .col.g2.g12-s
        label Bairro
        input(v-model="form.bairro" placeholder="Bairro")
      .col.g2.g12-s
        label UF
        input(v-model="form.estado" placeholder="Número")
      .col.g2.g12-s
        label Complemento
        input(v-model="form.complemento" placeholder="Complemento")       
      
    h3 DADOS BANCÁRIOS
    .row.g12.wp.col-s.ja
      .g3-g.g5-m.g12-s.label.col
        label Banco
        select.input(v-model="form.id_banco" required)
          option(value) Selecione
          option(v-for="(b, i) of banks" :value="b.id" :key="'bank' + i") {{ b.nome }} - ({{ b.codigo }})
      .g1-g.g3-m.g12-s.label.col
        label Agência
        input.input(v-model="form.agencia_banco" required)
      .g1-g.g2-m.g12-s.label.col
        label DV Agência
        input.input(v-model="form.dv_agencia_banco" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" min="0" max="9" maxlength="1" step="1")
      .g2-g.g3-m.g12-s.label.col
        label Conta
        input.input(v-model="form.conta_banco" required)
      .g1-g.g2-m.g12-s.label.col
        label DV Conta
        input(type="number" class="input" v-model="form.dv_conta_banco" maxlength="1" required)
      .g1-g.g3-m.g12-s.label.col
        label Tipo Conta
        select.input(v-model="form.tipo_conta" required)
          option(value) Selecione
          option(value="corrente") Conta Corrente
          option(value="poupanca") Conta Poupança
      .g2-g.g3-m.g12-s.label.col(v-if="form.id_banco == 55")
        label Operação Conta
        select(type="text" class="input" v-model="form.operacao_conta")
          option(value="null") Selecione
          option(value="001") 001 - Conta corrente de Pessoa Física
          option(value="003") 003 - Conta corrente de Pessoa Jurídica
          option(value="013") 013 - Poupança de pessoa Física
          option(value="022") 022 - Poupança de pessoa Jurídica
      //.g1-g.g3-m.g12-s.label.col
        label Titular da Conta
        select.input(v-model="form.titular_conta" required)
          option(value) Selecione
          option(value="pf") Pessoa Física
          option(value="pj") Pessoa Jurídica
      
    .info.row.wp.col-s.ja(v-if="form.nome_criado_por")
      .text-center.g6.g12-s.col
        label Criado por
        | {{ form.nome_criado_por }} em {{ form.criado_em | date }}
      .text-center.g6.g12-s.col(v-if="form.nome_alterado_por")
        label Alterado por
        | {{ form.nome_alterado_por }} em {{ form.alterado_em | date }}

    .controls.row.ja
      Button(type="submit" :loader="loader" layout="green-go")
        i.fa.fa-edit 
        | {{ form.update ? "ATUALIZAR" :"ADICIONAR" }}
      Button(v-if="form.update && form.status == 'ativo'" type="button" @click="del" :loader="loader" layout="red-go")
        i.fa.fa-trash 
        | DESATIVAR
      Button(v-if="form.update && form.status == 'inativo'" type="button" @click="updateStatus" :loader="loader" layout="green-go white")
        i.fa.fa-check
        | ATIVAR
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Button from "@/components/Button.vue";
import Vue from "vue";
import { VueMaskDirective } from "v-mask";
import format from '@/utils/format'
Vue.directive("mask", VueMaskDirective);

var initForm = {
  nome: "",
  cpf: "",
  rg: "",
  dt_nascimento: "",
  sexo: "",
  pcd: "",
  email: "",
  fone: "",
  celular: "",
  cep: "",
  cidade: "",
  logradouro: "",
  numero: "",
  bairro: "",
  estado: "",
  complemento: "",
  cnpj: "",
  razao_social: "",
  ns_community: "",
  id_banco: "",
  agencia_banco: "",
  dv_agencia_banco: "",
  conta_banco: "",
  tipo_conta: "",
  operacao_conta: "1",
/*   titular_conta: "", */
  id_gruṕo: null
};

export default {
  name: "FuncionarioForm",
  components: { Button },
  props: { f: Object, cb: Function },
  data() {
    return {
      form: { ...initForm },
      grupo: [],
      loader: false,
    };
  },
  methods: {
    ...mapActions("admin", ["FUNCIONARIO_UPDATE", "FUNCIONARIO_NOVO", "GROUP_LIST", "FUNCIONARIO_DEL", "FUNCIONARIO_ACTIVE"]),
    ...mapActions("user", ["GET_BANK", "PUT_BANK"]),
    ...mapActions("general", ["LOAD_BANK", "LOAD_CEP"]),
    cep() {
      if (this.form.cep.length > 9)
        this.LOAD_CEP(this.form.cep.replace(".", "").replace("-", "")).then((r) => {
          if (r.logradouro) {
            this.form.logradouro = r.logradouro;
            this.form.bairro = r.bairro;
            this.form.cidade = r.localidade;
            this.form.estado = r.uf;
          }
        });
    },
    clearForm(form) {
      form.celular = format.clear(form.celular)
      form.fone = format.clear(form.fone)
      form.cep = format.clear(form.cep)
      form.cpf = format.clear(form.cpf)
      form.cnpj = format.clear(form.cnpj)
      form.dt_nascimento = format.date(form.dt_nascimento)
      return form
    },
    async create() {
      let form = await this.clearForm({ ...this.form })
      return await this.FUNCIONARIO_NOVO(form).then(({ status }) => {
        if (status == 201 || status == 200) {
          this.form = { ...initForm }
          this.cb();
        }
      });
    },
    async update() {
      let form = await this.clearForm({ ...this.form })
      form.params = this.form.id
      return this.FUNCIONARIO_UPDATE(form).then(({ status }) => (status == 200 || status == 201) && this.cb());
    },
    async send() {
      this.loader = true;
      if (!this.f) await this.create()
      else await this.update()
      this.loader = false;
    },
    async updateStatus() {
      this.loader = true;
      await this.FUNCIONARIO_ACTIVE(this.form.id)
      this.cb()
      this.loader = false;
    },
    async del() {
      if (confirm(`Deseja desativar o Funcionário ${this.form.nome}?`)) {
        this.loader = true;
        await this.FUNCIONARIO_DEL(this.form.id).then(() => this.cb());
        this.loader = false
      }
    },
  },
  beforeMount() {
    if (this.f) this.form = { ...this.f }
    this.GROUP_LIST({ perfil: "funcionario" }).then(r => this.grupo = r.data || [])
    this.LOAD_BANK();
  },
  computed: {
    ...mapGetters("user", ["bank", "user"]),
    ...mapGetters("general", ["banks"]),
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.funcionarioForm
  @include form
  select
    width: 93%
    max-width: 93%
</style>
